"use client";

import {
  clearStoredChatNotificationToken,
  getStoredChatNotificationToken,
  unregisterChatNotificationDevice,
} from "./deviceRegistration";
import { deleteChatNotificationToken } from "./messaging";

export const cleanupChatNotificationsBeforeLogout = async (): Promise<void> => {
  const storedToken = getStoredChatNotificationToken();

  try {
    if (storedToken) await unregisterChatNotificationDevice(storedToken);
  } catch {
    // Firebase invalid-token cleanup removes the stale backend row if this
    // best-effort request is interrupted during navigation.
  } finally {
    try {
      await deleteChatNotificationToken();
    } catch {
      // Logout must still complete if the browser cannot reach Firebase.
    }
    clearStoredChatNotificationToken();
  }
};
